import { ContributorActionsApp } from '@scale/chat-lite-tool';
import { useQuery } from '@tanstack/react-query-v4';
import { Typography } from '@scale/scaleui';
import type { TransactionSet } from '@scale/chat-lite-tool/server';
import axios from 'axios';

const ContributorActionsWrapper = (props: $FIXME) => {
  const fetchTransactionHistory = async () => {
    const { data } = await axios.post<TransactionSet[]>(
      '/api/task-builder/tasks/transaction-history',
      {
        claimBody: {
          usingForceClaimLink: true,
        },
        transactionHistoryId: props.transactionHistoryId,
      },
    );
    return data;
  };

  const {
    data: contributorActions,
    isLoading: isLoadingTransactionHistory,
    error,
  } = useQuery({
    queryKey: ['transactionHistory', props.transactionHistoryId],
    queryFn: fetchTransactionHistory,
    enabled: !!props.transactionHistoryId,
    retry: 3,
    retryDelay: attemptIndex =>
      Math.min(1000 * Math.pow(2, attemptIndex) + Math.random() * 1000, 30_000),
  });

  const projectConfigs = props.assignment?.projectConfig;

  if (isLoadingTransactionHistory) {
    return <Typography.Subtitle2>Loading contributor actions...</Typography.Subtitle2>;
  }

  if (error) {
    const errorMessage = error instanceof Error ? error.message : 'An unexpected error occurred';

    return <Typography.Subtitle2 className="text-error-600">{errorMessage}</Typography.Subtitle2>;
  }

  if (!contributorActions || contributorActions.length === 0) {
    return <Typography.Subtitle2>No contributor actions found</Typography.Subtitle2>;
  }

  return (
    <ContributorActionsApp
      {...props}
      projectConfigs={projectConfigs}
      transactions={contributorActions}
    />
  );
};

export default ContributorActionsWrapper;
